var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSesStlabLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 259.49 76.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#e7c981;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.64,46.14c-1.23,5.37-5.27,8.92-11.9,8.92H29.24c-1,0-1.35-.49-1.13-1.41l1.29-6a1.61,1.61,0,0,1,1.68-1.46ZM4.87,30.8H56.36A1.59,1.59,0,0,0,58,29.34l1.3-6.05c.21-.92-.16-1.4-1.14-1.4H16.77c-6.64,0-10.67,3.55-11.9,8.91M27,46.14H3A1.59,1.59,0,0,0,1.36,47.6l-1.3,6c-.22.92.16,1.41,1.13,1.41H15.05c6.63,0,10.67-3.56,11.9-8.92M60.51,30.81H84.43a1.59,1.59,0,0,0,1.67-1.46l1.3-6.05c.22-.92-.16-1.4-1.13-1.4H72.41c-6.63,0-10.67,3.55-11.9,8.92m23,11.39a6.42,6.42,0,0,0-6.27-7.78H59.82a8.58,8.58,0,0,0-.06.92c0,4.37,2.81,6.86,8.16,6.86Zm-55.73,0a6.42,6.42,0,0,0-6.28-7.78H4.09a8.27,8.27,0,0,0,0,.92c0,4.37,2.81,6.86,8.16,6.86Zm27.77-1.08,1.08-5c.22-1-.16-1.41-1.13-1.41H33.54a1.52,1.52,0,0,0-1.67,1.41l-1.08,5c-.22,1,.16,1.4,1.13,1.4H53.84a1.52,1.52,0,0,0,1.67-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.18,28a.65.65,0,0,1,.73.73v3.14a.64.64,0,0,1-.73.72H112.64a1.63,1.63,0,0,0-1.35.5,2.07,2.07,0,0,0-.4,1.35v1.12c0,1.24.57,1.85,1.72,1.85H125a5.83,5.83,0,0,1,4.32,1.47,5.74,5.74,0,0,1,1.46,4.21v2.64a5.44,5.44,0,0,1-1.42,3.9,5.9,5.9,0,0,1-4.43,1.49H106.63c-.51,0-.76-.25-.76-.73V47.27c0-.48.25-.72.76-.72H124a1.66,1.66,0,0,0,1.36-.5,2.13,2.13,0,0,0,.39-1.35V43.34c0-1.23-.57-1.85-1.71-1.85H111.62A5.87,5.87,0,0,1,107.29,40a5.74,5.74,0,0,1-1.45-4.21V33.41a5.39,5.39,0,0,1,1.42-3.9A5.86,5.86,0,0,1,111.68,28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M178.67,28a.65.65,0,0,1,.73.73V41.92a9.64,9.64,0,0,0,.21,2.2,3.05,3.05,0,0,0,.71,1.39,2.75,2.75,0,0,0,1.34.72,8.44,8.44,0,0,0,2.13.22h13.37a.64.64,0,0,1,.73.72v3.24a.65.65,0,0,1-.73.73H183.59a16.83,16.83,0,0,1-4.26-.47,6.37,6.37,0,0,1-2.85-1.5,6,6,0,0,1-1.62-2.71,13.94,13.94,0,0,1-.51-4V28.75c0-.48.25-.73.76-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M215.52,28a4,4,0,0,1,2.11.52,5.19,5.19,0,0,1,1.68,2l10.93,19.85a.65.65,0,0,1,.08.54c0,.14-.21.22-.47.22h-4.2a.78.78,0,0,1-.76-.43l-2.34-4.26H207l-2.28,4.26a.8.8,0,0,1-.76.43H199.7c-.28,0-.46-.08-.51-.22a.65.65,0,0,1,.08-.54L210.1,30.53a5.51,5.51,0,0,1,1.62-2,3.26,3.26,0,0,1,1.85-.52Zm-6.41,14.6h11.36l-5.25-9.68a.41.41,0,0,0-.36-.23h-.2a.42.42,0,0,0-.37.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.06,28c2.26,0,3.87.46,4.83,1.36a5.34,5.34,0,0,1,1.44,4.09v1.59a4.74,4.74,0,0,1-2.11,4.19,4.56,4.56,0,0,1,2.27,4.26v1.91a9.13,9.13,0,0,1-.29,2.38,4.43,4.43,0,0,1-1,1.8,4.23,4.23,0,0,1-1.8,1.14,8.5,8.5,0,0,1-2.77.4H234a.88.88,0,0,1-1-1V29a.88.88,0,0,1,1-1Zm-15,9.61h13.54a3.66,3.66,0,0,0,2.24-.49,1.78,1.78,0,0,0,.59-1.46V34.56a1.85,1.85,0,0,0-.57-1.5,2.93,2.93,0,0,0-1.87-.48h-13.5a.38.38,0,0,0-.43.43Zm0,3.6v4.92a.38.38,0,0,0,.43.43h13.53A2.92,2.92,0,0,0,254,46.1a1.92,1.92,0,0,0,.56-1.53V43.31a2,2,0,0,0-.61-1.55,3.57,3.57,0,0,0-2.26-.53Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 146.19,
    y: 8.47,
    width: 4.37,
    height: 21.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 146.19,
    y: 39.09,
    width: 4.37,
    height: 22.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 139.48,
    y: 36.91,
    width: 17.79,
    height: 4.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 134.34,
    y: 28.06,
    width: 28.06,
    height: 4.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 96.18,
    width: 0.54,
    height: 76.94
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSesStlabLogo);
export default __webpack_public_path__ + "static/media/ses-stlab-logo.c51b32ef.svg";
export { ForwardRef as ReactComponent };